const list = [
  {
    name: '用户管理'
  },
  {
    name: '通知管理',
  },
  {
    name: '分类管理'
  },
  {
    name: '产业管理'
  },
  {
    name: '精选项目管理',
    children: [{
        name: '精选项目列表'
      },
      {
        name: '房源列表'
      },
      {
        name: '精选项目标签'
      }
    ]
  },
  {
    name: '云空间管理'
  },
  {
    name: '企业管理'
  },
  {
    name: '停车管理',
    children: [
      {
        name: '停车券管理'
      },
      {
        name: '停车记录'
      }
    ]
  },
  {
    name: '会议室管理',
    children: [
      {
        name: '会议室列表'
      },
      {
        name: '预约管理'
      },
      {
        name: '会议服务管理'
      },
      {
        name: '场地布局管理'
      }
    ]
  },
  {
    name: '电子放行管理'
  },
  {
    name: '投诉报修管理',
    children: [{
        name: '投诉建议列表'
      },
      {
        name: '在线报修列表'
      }
    ]
  },
  {
    name: '企业服务管理',
    children: [
      {
        name: '企业分类管理'
      },
      {
        name: '服务管理'
      },
      {
        name: '意向留言列表'
      }
    ]
  },
  {
    name: '内容管理',
    children: [
      {
        name: '轮播图管理'
      },
      {
        name: '资讯管理'
      },
    ]
  },
  {
    name: '权限管理',
    children: [
      {
        name: '菜单管理'
      },
      {
        name: '管理员列表'
      },
      {
        name: '身份管理'
      },
      {
        name: '操作日志'
      }
    ]
  },
]

export default list
